/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CnameverceldnscomInputs */

const en_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const es_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const fr_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const de_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const ja_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const zh_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const ar_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const id_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const it_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const ru_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const pt_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

const ko_cnameverceldnscom = /** @type {(inputs: CnameverceldnscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cname.vercel-dns.com`)
};

/**
* | output |
* | --- |
* | "cname.vercel-dns.com" |
*
* @param {CnameverceldnscomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cnameverceldnscom = /** @type {((inputs?: CnameverceldnscomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CnameverceldnscomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cnameverceldnscom(inputs)
	if (locale === "es") return es_cnameverceldnscom(inputs)
	if (locale === "fr") return fr_cnameverceldnscom(inputs)
	if (locale === "de") return de_cnameverceldnscom(inputs)
	if (locale === "ja") return ja_cnameverceldnscom(inputs)
	if (locale === "zh") return zh_cnameverceldnscom(inputs)
	if (locale === "ar") return ar_cnameverceldnscom(inputs)
	if (locale === "id") return id_cnameverceldnscom(inputs)
	if (locale === "it") return it_cnameverceldnscom(inputs)
	if (locale === "ru") return ru_cnameverceldnscom(inputs)
	if (locale === "pt") return pt_cnameverceldnscom(inputs)
	return ko_cnameverceldnscom(inputs)
});